// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../onehivesystems/js/OHSApp';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
import OHSWidget from '../../onehivesystems/js/OHSWidget';
import { OHSFormItem, OHSFormSubmit, OHSFormDataClearer, OHSFormDataExtractor } from '../../onehivesystems/js/OHSForm';
import { OHSListDataFormatter } from '../../onehivesystems/js/OHSList';
// Assets
import './Profile.scss';
import { userAccountModel } from './_variables';


// COMPONENT
export default function Profile (props) {
   // States and Variables
   const [userAccount, setUserAccount] = useState(userAccountModel);
   const [changePassword, setChangePassword] = useState(false);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("Profile"); // set page title
      getProfile();
   }, []);

   // Functions
   const getProfile = function () {
      OHSCRUD({
         url: '/v1/profile',
         method: 'GET',
         success: function (data) {
            setUserAccount(OHSListDataFormatter(data[0], userAccountModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const updateProfile = function () {
      OHSCRUD({
         url: '/v1/profile',
         method: 'PUT',
         payload: OHSFormDataExtractor('profile-information'),
         success: function (data) {
            setUserAccount(OHSListDataFormatter(data[0], userAccountModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteAccount = function () {
      OHSCRUD({
         url: '/v1/profile',
         method: 'DELETE',
         success: function (data) {
            logout();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete your account? This action is IRREVERSIBLE.",
         showSuccessPopup: false
      });
   }
   const logout = function () {
      window.location.href = "/login";
   }
   const toggleChangePassword = function () {
      setChangePassword(!changePassword);
   }

   // Component
   return (
      <div className="profile">
         <OHSAppHeader onehive={props.onehive} title="Profile" help="https://www.onehivesystems.com/documentation/profile" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget id='profile-information' title="Information" className="profile-information" onEnter={updateProfile}>
               <OHSFormItem title="Username">
                  <p className='profile-information-username'>{userAccount.username.value}</p>
               </OHSFormItem>
               <OHSFormItem title="First Name">
                  <input type='text' className='ohsinput' data-ohsformdata="first_name" placeholder="(Optional)" min={0} max={256} defaultValue={userAccount.first_name.value} />
               </OHSFormItem>
               <OHSFormItem title="Last Name">
                  <input type='text' className='ohsinput' data-ohsformdata="last_name" placeholder="(Optional)" min={0} max={256} defaultValue={userAccount.last_name.value} />
               </OHSFormItem>
               <OHSFormItem title="Password">
                  {changePassword ? 
                     <div className='profile-information-changepassword'>
                        <input type='password' className='ohsinput' data-ohsformdata='password' min={1} placeholder='Password' />
                        <input type='password' className='ohsinput' data-ohsformdata='confirm_password' min={1} placeholder='Confirm Password' />
                        <button className='ohsbtn-error' onClick={toggleChangePassword}>Cancel</button>
                     </div>
                  :
                     <button className='ohsbtn' onClick={toggleChangePassword}>Change Password</button>
                  }
               </OHSFormItem>
               <OHSFormSubmit update={updateProfile} clear={() => {OHSFormDataClearer('profile-information');}} keyListener={true} />
            </OHSWidget>
            <OHSWidget title="Account Actions" className="profile-accountactions">
               <button className='ohsbtn' onClick={logout}>Logout</button>
               <button className='ohsbtn-error' onClick={deleteAccount}>Delete Account</button>
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}